import React from 'react'
import { connect } from 'react-redux'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import history from 'core/history'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { loginRequest } from 'variables/authConfig'

import { validate } from '../ducks/authen'

import Layout from '../components/Layout'
import Home from './Home'
import Login from './Login'
import Logout from './Logout'
import VendorApplication from './ProcurementSystem/VendorApplication'

// QR Scanner
import QRScanner from 'routes/QRScanner'
import BillingScanDetail from 'routes/QRScanner/BillingScan'
// Tracking
import Tracking from './ProcurementSystem/Tracking'
import DetailTracking from './ProcurementSystem/Tracking/Detail'
// PR
import PurchaseRequisition from './ProcurementSystem/PurchaseRequisition'
import PurchaseRequisitionDetail from './ProcurementSystem/PurchaseRequisition/Details'
import PurchaseRequisitionEdit from './ProcurementSystem/PurchaseRequisition/Edit'
import CreatePurchaseRequisition from './ProcurementSystem/PurchaseRequisition/Create'
// RFQ
import RequestForQuotation from './ProcurementSystem/RequestForQuotation'
import CreateRequestForQuotation from './ProcurementSystem/RequestForQuotation/Create'
import EditRequestForQuotation from './ProcurementSystem/RequestForQuotation/Edit'
import DetailsRequestForQuotation from './ProcurementSystem/RequestForQuotation/Details'
// PO Update
import PurchaseOrderUpdate from './ProcurementSystem/POUpdate'
import CreatePurchaseOrderUpdate from './ProcurementSystem/POUpdate/Create'
import EditPurchaseOrderUpdate from './ProcurementSystem/POUpdate/Edit'
import DetailPurchaseOrderUpdate from './ProcurementSystem/POUpdate/Detail'
// PO
import PurchaseOrder from './ProcurementSystem/PurchaseOrder'
import PurchaseOrderDetail from './ProcurementSystem/PurchaseOrder/Detail'
import PurchaseOrderEdit from './ProcurementSystem/PurchaseOrder/Edit'
// Contract
import Contract from './ProcurementSystem/Contract'
import ContractCreate from './ProcurementSystem/Contract/Create'
import ContractDetail from './ProcurementSystem/Contract/Detail'
import ContractEdit from './ProcurementSystem/Contract/Edit'
// Down Payment
import DownPayment from './ProcurementSystem/DownPayment'
import DownpaymentDetail from './ProcurementSystem/DownPayment/Detail'
// Billing
import Billform from './ProcurementSystem/Billform'
import BillformDetail from './ProcurementSystem/Billform/Detail'
import CreateBillform from './ProcurementSystem/Billform/Create'
import EditBillForm from './ProcurementSystem/Billform/Edit'
import BlCover from './ProcurementSystem/Billform/Cover'
// GR
import GoodsServiceReceipt from './ProcurementSystem/GoodsServiceReceipt'
import CreateGoodsServiceReceipt from './ProcurementSystem/GoodsServiceReceipt/Create'
import EditGoodsServiceReceipt from './ProcurementSystem/GoodsServiceReceipt/Edit'
import DetailGoodsServiceReceipt from './ProcurementSystem/GoodsServiceReceipt/Detail'

// Code of Conduct
import CodeOfConduct from './ProcurementSystem/CodeOfConduct'
import CodeOfConductDetails from './ProcurementSystem/CodeOfConduct/Details'

//Admin
import Admin from './Admin'
import Support from './Admin/Support'
import Configuration from './Admin/Configuration'
import AdminUsers from './Admin/Configuration/AdminUsers'
import Announcement from './Admin/Configuration/Announcement'
import MaintenanceTime from './Admin/Configuration/MaintenanceTime'
import VendorManagement from './Admin/VendorManagement'
import VendorUserManagement from './Admin/VendorManagement/UserManagement'

// Master & Mapping Data
import MappingData from './Admin/MasterAndMappingData'
import ProvinceData from './Admin/MasterAndMappingData/ProvinceData'
import CompanyData from './Admin/MasterAndMappingData/CompanyData'

// PR Management
import PRManagement from './Admin/PRManagement'
import PrMappingData from './Admin/PRManagement/MappingData'

//Role Management
import RoleMan from './Admin/RoleMan'
import UserRoleSection from './Admin/RoleMan/UserRolesSection'
import RoleSection from './Admin/RoleMan/RoleSection'
import PermissionSection from './Admin/RoleMan/PermissionSection'
import AdjustDepartmentUserSection from './Admin/RoleMan/AdjustDepartmentUser'
import ProjectRoleSection from './Admin/RoleMan/ProjectRole'

import CompanyInFo_1 from './VenderCompanyInfo/MinRequireForm'
import CompanyInFo_2 from './VenderCompanyInfo/FullDetailsForm'

import Product from './Product'
import ProductDetail from './Product/Details'

// Report
import EReport from './Report'
import EReportRoles from './Report/Roles'

// import ProductForm from './Product/Form'

// Vendor Maintenance
import VendorMaintenance from './VendorMaintenance'
import VendorMaintenanceCreate from './VendorMaintenance/Create'
import VendorMaintenanceEdit from './VendorMaintenance/Edit'
import VendorMaintenanceDetail from './VendorMaintenance/Detail'

//Supplier
import Supplier from './Suppliers'
import SupplierConvert from './Suppliers/Edit'

// Short List
import ShortList from './ShortList'
import ShortListCreate from './ShortList/Create'
import ShortListEdit from './ShortList/Edit'
import ShortListDetail from './ShortList/Detail'

// Bank Guarantee Vendor
import BGVendorReport from './BankGuarantee/Vendor/Report'
import BGVendorCreate from './BankGuarantee/Vendor/Report/Create'
import BGVendorEdit from './BankGuarantee/Vendor/Report/Edit'
import BGVendorDetail from './BankGuarantee/Vendor/Report/Detail'

import BGVendorRequest from './BankGuarantee/Vendor/Request'
import BGVendorRequestCreate from './BankGuarantee/Vendor/Request/Create'
import BGVendorRequestEdit from './BankGuarantee/Vendor/Request/Edit'
import BGVendorRequestDetail from './BankGuarantee/Vendor/Request/Detail'
import BGVendorRequestPrintForm from './BankGuarantee/Vendor/Request/PrintForm'

// Bank Guarantee Company
import BGCompanyReport from './BankGuarantee/Company/Report'
import BGCompanyReportEdit from './BankGuarantee/Company/Report/Edit'
import BGCompanyReportDetail from './BankGuarantee/Company/Report/Detail'

import BGCompanyRequest from './BankGuarantee/Company/Request'
import BGCompanyRequestCreate from './BankGuarantee/Company/Request/Create'
import BGCompanyRequestEdit from './BankGuarantee/Company/Request/Edit'
import BGCompanyRequestDetail from './BankGuarantee/Company/Request/Detail'

import BGCompanyLimitBank from './BankGuarantee/Company/Bank'
import BGCompanyLimitBankCreate from './BankGuarantee/Company/Bank/Create'
import BGCompanyLimitBankEdit from './BankGuarantee/Company/Bank/Edit'
import BGCompanyLimitBankDetail from './BankGuarantee/Company/Bank/Detail'

// RFP
import RFPLandingPage from './ProcurementSystem/Rfp'
import RFPDetail from './ProcurementSystem/Rfp/Detail'

// SupportForUser
import SupportForUser from './SupportForUser'
import PrMainSupportForUser from './SupportForUser/PR'
import CancelPRSupportForUser from './SupportForUser/PR/PRCancel'
import GrMainSupportForUser from './SupportForUser/GR'
import CancelGrSupportForUser from './SupportForUser/GR/GRCancel'
import RoleMainSupportForUser from './SupportForUser/Report'
import SearchByUsernameSupportForUser from './SupportForUser/Report/SearchRoleByUsername'
import SearchByRoleSupportForUser from './SupportForUser/Report/SearchUserByRole'

export const rootPath = ''
export const logoutPath = `${rootPath}/logout`

//QR Scanner
export const qrScannerPath = `${rootPath}/qrScanner`
export const qrScannerBillingDetailPath = (id,system) => `${rootPath}/qrScanner/bl/${system}/${id}`

//Admin
export const adminPath = `${rootPath}/admin`
export const supportPath = `${adminPath}/support`
export const configPath = `${adminPath}/configuration`
export const prManagementPath = `${adminPath}/prManagements`
export const masterDataPath = `${adminPath}/masterData`
export const vendorManagementPath = `${adminPath}/vendor`
export const vendorUserManagementPath = `${vendorManagementPath}/users`

export const announcementPath = `${configPath}/announcement`
export const adminUsersPath = `${configPath}/adminUsers`
export const maintenanceTimePath = `${configPath}/maintenanceTime`

export const provinceDataPath = `${masterDataPath}/provinceData`
export const companyDataPath = `${masterDataPath}/companyData`

export const prMappingDataPath = `${prManagementPath}/mappings/`
export const prMappingOrderGLPath = `${prMappingDataPath}/orderGLAccounts`
export const prMappingWbsAssetPath = `${prMappingDataPath}/wbsAssets`

// export const roleManPath = `${rootPath}/admin/role`
export const userRoleSectionPath = `${rootPath}/admin/userRole`
export const roleSectionPath = `${rootPath}/admin/role`
export const permissionSectionPath = `${rootPath}/admin/permission`
export const adjustDepartmentUserSectionPath = `${rootPath}/admin/adjustDepartmentUser`
export const ProjectRoleSectionPath = `${rootPath}/admin/projectRoles`

export const homePath = `${rootPath}/`
export const loginPath = `${rootPath}/login`
export const vendorApplicationPath = `${rootPath}/procurement/vendorApplication`
//Tracking
export const trackingPath = `${rootPath}/procurement/tracking`
export const trackingDetailPath = (id) => `${trackingPath}/${id}`

//PR
export const purchaseRequisitionPath = `${rootPath}/procurement/purchaseRequisition`
export const purchaseRequisitionCreatePath = `${purchaseRequisitionPath}/create`
export const purchaseRequisitionDetailPath = (id) => `${purchaseRequisitionPath}/${id}`
export const purchaseRequisitionEditPath = (id) => `${purchaseRequisitionPath}/${id}/edit`
// RFQ
export const requestForQuotationPath = `${rootPath}/procurement/requestForQuotation`
export const requestForQuotationCreatePath = `${requestForQuotationPath}/create`
export const requestForQuotationDetailPath = (id) => `${requestForQuotationPath}/${id}`
export const requestForQuotationEditPath = (id) => `${requestForQuotationPath}/${id}/edit`
// PO Update
export const purchaseOrderUpdatePath = `${rootPath}/procurement/purchaseOrderUpdate`
export const purchaseOrderUpdateCreatePath = `${purchaseOrderUpdatePath}/create`
export const purchaseOrderUpdateDetailPath = (id) => `${purchaseOrderUpdatePath}/${id}`
export const purchaseOrderUpdateEditPath = (id) => `${purchaseOrderUpdatePath}/${id}/edit`
//PO
export const purchaseOrderPath = `${rootPath}/procurement/purchaseOrder`
export const purchaseOrderCreatePath = `${purchaseOrderPath}/create`
export const purchaseOrderDetailPath = (id) => `${purchaseOrderPath}/${id}`
export const purchaseOrderEditPath = (id) => `${purchaseOrderPath}/${id}/edit`
// Contract
export const contractPath = `${rootPath}/legalsystem/contract`
export const contractCreatePath = `${contractPath}/create`
export const contractDetailPath = (id) => `${contractPath}/${id}`
export const contractEditPath = (id) => `${contractPath}/${id}/edit`
// DownPayment
export const downPaymentPath = `${rootPath}/procurement/downpayment`
export const downPaymentDetailPath = (id) => `${downPaymentPath}/${id}`

// Code Of Conduct
export const codeOfConductPath = `${rootPath}/procurement/CodeOfConduct`
export const codeOfConductDetailsPath = (id) => `${codeOfConductPath}/${id}`

//Billing
export const billFormPath = `${rootPath}/procurement/billform`
export const billFormCreatePath = `${billFormPath}/create`
export const BillformDetailPath = (Id) => `${billFormPath}/${Id}`
export const EditBillFormPath = (Id) => `${billFormPath}/${Id}/edit`
export const billCoverPath = (id) => `${billFormPath}/${id}/cover`

//GR
export const goodsServiceReceiptPath = `${rootPath}/procurement/goodsServiceReceipt`
export const goodsServiceReceiptCreatePath = `${goodsServiceReceiptPath}/create`
export const goodsServiceReceiptDetailPath = (id) => `${goodsServiceReceiptPath}/${id}`
export const goodsServiceReceiptEditPath = (id) => `${goodsServiceReceiptPath}/${id}/edit`

export const companyInfoMinPath = `${rootPath}/form_min`
export const companyInfoFullPath = `${rootPath}/form_full`

export const productPath = `${rootPath}/product`
export const productNewPath = `${productPath}/create/`
export const productDetailPath = (id) => `${productPath}/${id}`

//Report
export const reportPath = `${rootPath}/ext/report`
export const reportRolesPath = `${rootPath}/ext/report/roles`

// Vendor Maintenance
export const vmPath = `${rootPath}/vendorMaintenance`
export const vmCreatePath = `${vmPath}/create`
export const vmEditPath = (id) => `${vmPath}/${id}/edit`
export const vmDetailPath = (id) => `${vmPath}/${id}`

//Supplier
export const supplierPath = `${rootPath}/supplier`
export const supplierConvertPath = (id) => `${supplierPath}/convert/${id}`

// Short List
export const shortListPath = `${rootPath}/shortList`
export const shortListCreatePath = `${shortListPath}/create`
export const shortListEditPath = (id) => `${shortListPath}/${id}/edit`
export const shortListDetailPath = (id) => `${shortListPath}/${id}`

// Bank Guarantee
export const bgPath = `${rootPath}/bankGuarantee`
const bgVendor = `${bgPath}/vendor`
export const bgVendorReportPath = `${bgVendor}/report`
export const bgVendorCreatePath = (type) => `${bgVendor}/create/${type}`
export const bgVendorEditPath = (id) => `${bgVendor}/${id}/edit`
export const bgVendorDetailPath = (id) => `${bgVendor}/${id}/detail`
export const bgVendorRequestPath = `${bgVendor}/request`
export const bgVendorRequestCreatePath = `${bgVendorRequestPath}/create`
export const bgVendorRequestEditPath = (id) => `${bgVendorRequestPath}/${id}/edit`
export const bgVendorRequestDetailPath = (id) => `${bgVendorRequestPath}/${id}/detail`
export const bgVendorRequestPrintFormPath = (id) => `${bgVendorRequestPath}/${id}/printForm`
const bgCompany = `${bgPath}/company`
export const bgCompanyReportPath = `${bgCompany}/report`
export const bgCompanyReportDetailPath = (id) => `${bgCompanyReportPath}/${id}`
export const bgCompanyReportEditPath = (id) => `${bgCompanyReportPath}/${id}/edit`
export const bgCompanyRequestPath = `${bgCompany}/request`
export const bgCompanyRequestCreatePath = `${bgCompanyRequestPath}/create`
export const bgCompanyRequestEditPath = (id) => `${bgCompanyRequestPath}/${id}/edit`
export const bgCompanyRequestDetailPath = (id) => `${bgCompanyRequestPath}/${id}`
export const bgCompanyLimitBankPath = `${bgCompany}/bank`
export const bgCompanyLimitBankCreatePath = `${bgCompanyLimitBankPath}/create`
export const bgCompanyLimitBankEditPath = (id) => `${bgCompanyLimitBankPath}/${id}/edit`
export const bgCompanyLimitBankDetailPath = (id) => `${bgCompanyLimitBankPath}/${id}`

//RFP
export const rfpPath = `${rootPath}/rfp`
export const rfpDetailPath = (id) => `${rfpPath}/${id}`

//SupportForuser
export const supportForUserPath = `${rootPath}/support`
export const prMainSupportForUserPath = `${supportForUserPath}/pr`
export const cancelPRSupportForUserPath = `${prMainSupportForUserPath}/cancelpr`
export const grMainSupportForUserPath = `${supportForUserPath}/gr`
export const cancelGrSupportForUserPath = `${grMainSupportForUserPath}/cancelgr`
export const roleMainSupportForUserPath = `${supportForUserPath}/role`
export const searchByUsernameSupportForUserPath = `${roleMainSupportForUserPath}/searchbyusername`
export const searchByRolenameSupportForUserPath = `${roleMainSupportForUserPath}/searchbyrole`

const ApplicationRoutes = (props) => {
  const { instance, accounts } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  React.useEffect(()=>{
    if (isAuthenticated) {
      instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        localStorage.setItem('accessToken', response.accessToken)
        if(!response.fromCache){
          window.location.reload()
        }else{
          props.validate(history)
        }
      })
      .catch((response) => {
        localStorage.removeItem('accessToken')
        instance.logout({postLogoutRedirectUri: '/'})
      })
    }
  },[isAuthenticated])

  if (history && history.location && history.location.pathname === '//') {
    history.replace(rootPath)
  }

  return (
    <Router history={history}>
      {
        window.location.pathname?.includes(qrScannerPath) ?
          <Switch>
            <Route exact strict path={qrScannerPath} component={QRScanner} key='QRScanner' />
            {isAuthenticated && localStorage.getItem('maintenanceStartTime') === null ?
              <Route exact strict path={qrScannerBillingDetailPath(':id',':system')} component={BillingScanDetail} key='QRScannerBilling' />
              :
              <Route exact path={rootPath} component={Login} key='Login' />
            }
          </Switch>
          :
          <React.Fragment>
            {isAuthenticated && localStorage.getItem('maintenanceStartTime') === null ?
              <Layout>
                <Route exact strict path={homePath} component={Home} />

                {/* <Route exact strict path={roleManPath} component={RoleMan} /> */}

                <Route exact strict path={userRoleSectionPath} component={UserRoleSection} />
                <Route exact strict path={roleSectionPath} component={RoleSection} />
                <Route exact strict path={permissionSectionPath} component={PermissionSection} />
                <Route exact strict path={adjustDepartmentUserSectionPath} component={AdjustDepartmentUserSection} />
                <Route exact strict path={ProjectRoleSectionPath} component={ProjectRoleSection} />
                {/* Tracking */}
                <Route exact strict path={trackingPath} component={Tracking} />
                <Route exact strict path={trackingDetailPath(':tkId')} component={DetailTracking} key='TrackingDetail' />
                {/* Vendor Application */}
                <Route exact strict path={vendorApplicationPath} component={VendorApplication} />
                {/* PR */}
                <Route exact strict path={purchaseRequisitionPath} component={PurchaseRequisition} />
                <Switch>
                  <Route exact strict path={purchaseRequisitionCreatePath} component={CreatePurchaseRequisition} key='PRNew' />
                  <Route exact strict path={purchaseRequisitionDetailPath(':prId')} component={PurchaseRequisitionDetail} key='PRDetail' />
                </Switch>
                <Route exact strict path={purchaseRequisitionEditPath(':prId')} component={PurchaseRequisitionEdit} key='PREdit' />
                {/* RFQ */}
                <Route exact strict path={requestForQuotationPath} component={RequestForQuotation} />
                <Switch>
                  <Route exact strict path={requestForQuotationCreatePath} component={CreateRequestForQuotation} key='RFQNew' />
                  <Route exact strict path={requestForQuotationDetailPath(':rfqId')} component={DetailsRequestForQuotation} key='RFQDetail' />
                </Switch>
                <Route exact strict path={requestForQuotationEditPath(':rfqId')} component={EditRequestForQuotation} key='RFQEdit' />
                {/* PO Update */}
                <Route exact strict path={purchaseOrderUpdatePath} component={PurchaseOrderUpdate} />
                <Switch>
                  <Route exact strict path={purchaseOrderUpdateCreatePath} component={CreatePurchaseOrderUpdate} key='POUNew' />
                  <Route exact strict path={purchaseOrderUpdateDetailPath(':pouId')} component={DetailPurchaseOrderUpdate} key='POUDetail' />
                </Switch>
                <Route exact strict path={purchaseOrderUpdateEditPath(':pouId')} component={EditPurchaseOrderUpdate} key='POUEdit' />
                {/* PO */}
                <Route exact strict path={purchaseOrderPath} component={PurchaseOrder} key='PO' />
                <Switch>
                  <Route exact strict path={purchaseOrderDetailPath(':poId')} component={PurchaseOrderDetail} key='PODetail' />
                  <Route exact strict path={purchaseOrderEditPath(':poId')} component={PurchaseOrderEdit} key='POEdit' />
                </Switch>
                {/* Contract */}
                <Route exact strict path={contractPath} component={Contract} key='Contract' />
                <Switch>
                  <Route exact strict path={contractCreatePath} component={ContractCreate} key='ContractCreate' />
                  <Route exact strict path={contractDetailPath(':contractId')} component={ContractDetail} key='ContractDetail' />
                </Switch>
                <Route exact strict path={contractEditPath(':contractId')} component={ContractEdit} key='ContractEdit' />
                {/* Down Payment */}
                <Route exact strict path={downPaymentPath} component={DownPayment} key='DownPayment' />
                <Switch>
                  <Route exact strict path={downPaymentDetailPath(':dpId')} component={DownpaymentDetail} key='downpaymentDetail' />
                </Switch>
                {/* GR */}
                <Route exact strict path={goodsServiceReceiptPath} component={GoodsServiceReceipt} />
                <Switch>
                  <Route exact strict path={goodsServiceReceiptCreatePath} component={CreateGoodsServiceReceipt} key='GRNew' />
                  <Route exact strict path={goodsServiceReceiptDetailPath(':grId')} component={DetailGoodsServiceReceipt} key='GRDetail' />
                </Switch>
                <Route exact strict path={goodsServiceReceiptEditPath(':grId')} component={EditGoodsServiceReceipt} key='GREdit' />

                {/* Code of Conduct */}
                <Route exact strict path={codeOfConductPath} component={CodeOfConduct} key='CodeOfConduct' />
                <Switch>
                  <Route exact strict path={codeOfConductDetailsPath(':scId')} component={CodeOfConductDetails} key='CodeOfConductPath' />
                </Switch>

                {/* Billing */}
                <Route exact strict path={billFormPath} component={Billform} key='Billform' />
                <Switch>
                  <Route exact strict path={billFormCreatePath} component={CreateBillform} key='BLNew' />
                  <Route exact strict path={BillformDetailPath(':blId')} component={BillformDetail} key='BillformDetail' />
                  <Route exact strict path={EditBillFormPath(':blId')} component={EditBillForm} key='BLEdit' />
                  <Route exact strict path={billCoverPath(':blId')} component={BlCover} key='BillingCover' />
                </Switch>

                <Route exact path={productPath} component={Product} key='Product' />
                <Route exact strict path={productDetailPath(':productId')} component={ProductDetail} key='ProductDetails' />
                {/* <Route exact strict path={productNewPath} component={ProductForm} key='ProductNew' /> */}
                <Route exact strict path={companyInfoMinPath} component={CompanyInFo_1} />
                <Route exact strict path={companyInfoFullPath} component={CompanyInFo_2} />

                <Route exact strict path={vmPath} component={VendorMaintenance} key='VendorMaintenance' />
                <Switch>
                  <Route exact strict path={vmCreatePath} component={VendorMaintenanceCreate} key='VendorMaintenanceCreate' />
                  <Route exact strict path={vmEditPath(':id')} component={VendorMaintenanceEdit} key='VendorMaintenanceEdit' />
                  <Route exact strict path={vmDetailPath(':id')} component={VendorMaintenanceDetail} key='VendorMaintenanceDetail' />
                </Switch>

                {/* Supplier */}
                <Route exact strict path={supplierPath} component={Supplier} key='Suppliers' />
                <Switch>
                  <Route exact strict path={supplierConvertPath(':id')} component={SupplierConvert} key='SupplierConvert' />
                </Switch>

                {/* Report */}
                <Route exact strict path={reportPath} component={EReport} key='eReport' />
                <Route exact strict path={reportRolesPath} component={EReportRoles} key='eReportRoles' />

                {/* Short List */}
                <Route exact strict path={shortListPath} component={ShortList} key='shortList' />
                <Switch>
                  <Route exact strict path={shortListCreatePath} component={ShortListCreate} key='shortListCreate' />
                  <Route exact strict path={shortListEditPath(':id')} component={ShortListEdit} key='shortListEdit' />
                  <Route exact strict path={shortListDetailPath(':id')} component={ShortListDetail} key='shortListDetail' />
                </Switch>

                {/* Bank Guarantee Vendor*/}
                <Switch>
                  <Route exact strict path={bgVendorReportPath} component={BGVendorReport} key='bgVendorReport' />
                  <Route exact strict path={bgVendorCreatePath(':type')} component={BGVendorCreate} key='bgVendorCreate' />
                  <Route exact strict path={bgVendorEditPath(':id')} component={BGVendorEdit} key='bgVendorEdit' />
                  <Route exact strict path={bgVendorDetailPath(':id')} component={BGVendorDetail} key='bgVendorDetail' />
                  <Route exact strict path={bgVendorRequestPath} component={BGVendorRequest} key='bgVendorRequest' />
                  <Route exact strict path={bgVendorRequestCreatePath} component={BGVendorRequestCreate} key='bgVendorRequestCreate' />
                  <Route exact strict path={bgVendorRequestEditPath(':id')} component={BGVendorRequestEdit} key='bgVendorRequestEdit' />
                  <Route exact strict path={bgVendorRequestDetailPath(':id')} component={BGVendorRequestDetail} key='bgVendorRequestDetail' />
                  <Route exact strict path={bgVendorRequestPrintFormPath(':id')} component={BGVendorRequestPrintForm} key='bgVendorRequestPrintForm' />
                </Switch>

                {/* Bank Guarantee Company*/}
                <Switch>
                  <Route exact strict path={bgCompanyReportPath} component={BGCompanyReport} key='bgCompanyReport' />
                  <Route exact strict path={bgCompanyReportEditPath(':id')} component={BGCompanyReportEdit} key='bgCompanyReportEdit' />
                  <Route exact strict path={bgCompanyReportDetailPath(':id')} component={BGCompanyReportDetail} key='bgCompanyReportDetail' />
                  <Route exact strict path={bgCompanyRequestPath} component={BGCompanyRequest} key='bgCompanyRequest' />
                  <Route exact strict path={bgCompanyRequestCreatePath} component={BGCompanyRequestCreate} key='bgCompanyRequestCreate' />
                  <Route exact strict path={bgCompanyRequestEditPath(':id')} component={BGCompanyRequestEdit} key='bgCompanyRequestEdit' />
                  <Route exact strict path={bgCompanyRequestDetailPath(':id')} component={BGCompanyRequestDetail} key='bgCompanyRequestDetail' />
                  {/* Bank Guarantee Company Limit of Bank */}
                  <Route exact strict path={bgCompanyLimitBankPath} component={BGCompanyLimitBank} key='bgCompanyLimitBank' />
                  <Route exact strict path={bgCompanyLimitBankCreatePath} component={BGCompanyLimitBankCreate} key='bgCompanyLimitBankCreate' />
                  <Route exact strict path={bgCompanyLimitBankEditPath(':id')} component={BGCompanyLimitBankEdit} key='bgCompanyLimitBankEdit' />
                  <Route exact strict path={bgCompanyLimitBankDetailPath(':id')} component={BGCompanyLimitBankDetail} key='bgCompanyLimitBankDetail' />
                </Switch>

                {/* Admin */}
                <Route exact strict path={adminPath} component={Admin} key='admin' />
                <Switch>
                  <Route exact strict path={supportPath} component={Support} key='support' />
                  <Route exact strict path={configPath} component={Configuration} key='configuration' />
                  <Route exact strict path={adminUsersPath} component={AdminUsers} key='adminUsers' />
                  <Route exact strict path={announcementPath} component={Announcement} key='announcement' />
                  <Route exact strict path={maintenanceTimePath} component={MaintenanceTime} key='maintenanceTime' />
                  {/* Master & Mapping Data */}
                  <Route exact strict path={masterDataPath} component={MappingData} key='masterAndMappingData' />
                  <Route exact strict path={provinceDataPath} component={ProvinceData} key='provinceData' />
                  <Route exact strict path={companyDataPath} component={CompanyData} key='companyData' />
                  {/* PR Management */}
                  <Route exact strict path={prManagementPath} component={PRManagement} />
                  <Route exact strict path={prMappingDataPath} component={PrMappingData} />
                  {/* Vendor Management */}
                  <Route exact strict path={vendorManagementPath} component={VendorManagement} />
                  <Route exact strict path={vendorUserManagementPath} component={VendorUserManagement} />
                </Switch>
                <Switch>
                  <Route exact path={logoutPath} component={Logout} key='Logout' />
                </Switch>

                {/* RFP */}
                <Switch>
                  <Route exact strict path={rfpPath} component={RFPLandingPage} key='rfp' />
                  <Route exact strict path={rfpDetailPath(':id')} component={RFPDetail} key='rfpDetail' />
                </Switch>
                {/* Support for user */}
                <Switch>
                  <Route exact path={supportForUserPath} component={SupportForUser} key='supportForUser' />
                  <Route exact path={prMainSupportForUserPath} component={PrMainSupportForUser} key='prMainSupportForUser' />
                  <Route exact path={cancelPRSupportForUserPath} component={CancelPRSupportForUser} key='CancelPRSupportForUser' />
                  <Route exact path={grMainSupportForUserPath} component={GrMainSupportForUser} key='grMainSupportForUser' />
                  <Route exact path={cancelGrSupportForUserPath} component={CancelGrSupportForUser} key='CancelGRSupportForUser' />
                  <Route exact path={roleMainSupportForUserPath} component={RoleMainSupportForUser} key='RoleMainSupportForUser' />
                  <Route exact path={searchByUsernameSupportForUserPath} component={SearchByUsernameSupportForUser} key='SearchByUsernameSupportForUser' />
                  <Route exact path={searchByRolenameSupportForUserPath} component={SearchByRoleSupportForUser} key='SearchByRoleSupportForUser' />
                </Switch>
              </Layout>
              :
              <React.Fragment>
                <Route exact path={rootPath} component={Login} key='Login' />
                <Switch>
                  <Route exact path={logoutPath} component={Logout} key='Logout' />
                </Switch>
              </React.Fragment>
            }
          </React.Fragment>
      }
    </Router>
  )
}

const mapStateToProps = (state) => ({
  user: state.authen.user,
})

const mapDispatchToProps = {
  validate
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationRoutes)